<template>
    <span class="day-events">
        <span v-for="event in events" v-bind:key="event.title" class="event" :title="event.title" :style="`--color:${event.color}`"></span>
    </span>
</template>

<script>
export default {
	name: "KappKalenderEvent",
	props: [ 'events', 'tstamp' ],
	data() {
		return {
			// foundEvents : []
		};
	},
	computed: {
		todayEvents: function () {

			let todayEvents = Object.values(this.events);

			if ( todayEvents.length ) {

				let today = new Date();
				today.setTime(this.tstamp * 1000);

			}
			return todayEvents;
		}
	},
	methods: {
		// getClasses: function ( evt ) {
		// 	let today = new Date();
		// 	today.setTime(this.tstamp * 1000);
        //
		// 	let className = [ 'event' ],
        //
		// 		start = new Date(evt.start * 1000),
		// 		end = new Date(evt.end * 1000);
        //
		// 	if ( start.isBefore(today, 'day') ) className.push('event--before');
		// 	if ( end.isAfter(today, 'day') ) className.push('event--after');
        //
		// 	return className;
        //
		// }
	}
};
</script>

<style scoped>
.day-events {
    position: absolute;
    top: 11px;
    left: 0;
    width: 100%;
    transform: translateY(-50%);
}

.event {
    position: absolute;
    /*top: 11px;*/
    /*left: 50%;*/
    width: 8px;
    height: 8px;
    display: inline-block;
    transform: translate(-50%, -50%);
    background-color: var(--color-primary, #004F95);
    border-radius: 8px;
    z-index: 5;
    /*border: 2px solid #FFF;*/
    box-sizing: content-box;
}

.event + .event {
    margin-right: -5px;
}

/*.event:nth-child(2) {*/
/*    top: 9px;*/
/*}*/

/*.event:nth-child(3) {*/
/*    top: 4px;*/
/*}*/


.event--before {
    left: 0;
    width: 50%;
    width: calc(50% + 8px);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: 0;
    transform: translateY(-50%);
}

.event--after {
    right: 0;
    left: auto;
    width: 50%;
    width: calc(50% + 8px);
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    transform: translateY(-50%);
}

.event--before.event--after {
    /*width: 100%;*/
    left: -1px;
    right: -1px;
    width: auto;
    transform: translateY(-50%);
}
</style>
